import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { MessageService } from '@services/helpers/message-service/message.service';
import { JobsDataServiceProvider } from '@services/job/jobs.data.service';

@Component({
	selector: 'delete-job-modal',
	template: require('./delete-job-modal.html')
})
export class DeleteJobModalComponent implements OnInit {
	@Input() jobIdForDelete: number;
	@Output()
	updateParentTrigger: EventEmitter<boolean> = new EventEmitter<boolean>();
	disableButtons: boolean;
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private messageService: MessageService,
		private jobsDataService: JobsDataServiceProvider
	) {}

	ngOnInit() {}

	deleteJob(): void {
		this.disableButtons = true;

		this.jobsDataService
			.deleteJob(this.jobIdForDelete)
			.finally(() => (this.disableButtons = false))
			.subscribe(
				() => {
					this.messageService.showToaster('s_0', 'jobView');

					$('#deleteJobModal').modal('hide');
					this.updateParentTrigger.emit(true);
					this.updateGraphsModel(['shoots', 'payments']);
				},
				error => this.errorDeleteJob(error)
			);
	}

	private errorDeleteJob({ status, data }) {
		const errorMessage = data.errorMessage;
		let errorCode, errorPlace, value;

		if (status >= 400 && status < 500 && errorMessage) {
			if (
				errorMessage.includes(
					'This payment cannot be marked as unpaid because it was overpaid in Xero.'
				)
			) {
				errorCode = 'e_12';
				errorPlace = 'xero';
				value = 'job';
			} else {
				this.messageService.handleError({ error: data });
				return;
			}
		} else {
			errorCode = 'e_0';
			errorPlace = 'general';
		}
		this.messageService.showToaster(errorCode, errorPlace, value);
	}

	private updateGraphsModel = function(tabs) {
		window.snCommunicationAdapter.callMethod('updateGraphsModel', tabs);
	};
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/jobs/modals/delete-job-modal/delete-job-modal.ts